module.exports = __webpack_public_path__ + "static/the-theocons-2ee74445e9fe388a6b8a6cbd335ece5e.jpg";